import { Autocomplete, TextField, TextFieldProps } from "@mui/material";
import { useMemo } from "react";

import { useCarrierRuleSelectionQuery } from "../../../hooks/useBbe";
import { CarrierRuleSelection } from "../types";

type CarrierRuleSelectProps = {
  carrierId: string;
  value: CarrierRuleSelection | null;
  onChange: (value: CarrierRuleSelection | null) => void;
  label: string;
  textFieldProps?: TextFieldProps;
  disabled?: boolean;
};

export const CarrierRuleSelect: React.FC<CarrierRuleSelectProps> = ({
  carrierId,
  value,
  onChange,
  label,
  disabled,
  textFieldProps,
}) => {
  const carrierRuleSelectionsQuery = useCarrierRuleSelectionQuery();
  const rulesByCarrier = useMemo(() => {
    if (!carrierRuleSelectionsQuery?.data) return [];

    return carrierRuleSelectionsQuery.data.filter(
      (rule) => rule.carrierId === carrierId,
    );
  }, [carrierId, carrierRuleSelectionsQuery.data]);

  return (
    <Autocomplete
      disableClearable
      data-testid="carrier-rule-autocomplete"
      renderInput={(params) => (
        <TextField {...params} label={label} {...textFieldProps} />
      )}
      options={rulesByCarrier}
      getOptionLabel={(option) => option.ruleTitle}
      value={value}
      onChange={(_, newValue) => onChange(newValue)}
      sx={{ flex: 1 }}
      isOptionEqualToValue={(option, val) =>
        option.carrierRuleId === val.carrierRuleId
      }
      disabled={disabled}
    />
  );
};
